import { render } from "./ModalDeleteLocationDetails.vue?vue&type=template&id=b18233ee"
import script from "./ModalDeleteLocationDetails.vue?vue&type=script&lang=js"
export * from "./ModalDeleteLocationDetails.vue?vue&type=script&lang=js"

import "./ModalDeleteLocationDetails.vue?vue&type=style&index=0&id=b18233ee&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__